import { render, staticRenderFns } from "./FixedBenefitDetail.vue?vue&type=template&id=dc86b572&scoped=true"
import script from "./FixedBenefitDetail.vue?vue&type=script&lang=js"
export * from "./FixedBenefitDetail.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&id=dc86b572&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc86b572",
  null
  
)

export default component.exports